export default __webpack_public_path__ + "static/media/element_spec_86.e39728da.webp";